import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { CollectionPurposeDataProvider } from "../../data-provider/collection-purpose.dp";

let LegalReasonCreateDialogComponent = {
    selector: "vcLegalReasonCreate",
    templateUrl:
        "/angular/components/collection-purpose/legal-reason-create-dialog.component.html",
    bindings: {},
    controller: class LegalReasonCreateController {
        private dialog: DialogUtils;
        private toast: ToastUtils;
        private dataProvider: CollectionPurposeDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            CollectionPurposeDataProvider: CollectionPurposeDataProvider
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.dataProvider = CollectionPurposeDataProvider;
        }

        cancel(): void {
            this.dialog.cancel();
        }

        createCollectionReason(purpose: object): void {
            this.dataProvider.createPurpose(purpose).then(
                (createdPurpose: object) => {
                    this.toast.success("Data collection purpose created");
                    this.dialog.hide(createdPurpose);
                },
                (error: object) => this.toast.error(error)
            );
        }
    },
};

angular
    .module("collectionpurpose")
    .component(
        LegalReasonCreateDialogComponent.selector,
        LegalReasonCreateDialogComponent
    );
